import { ExportTableNames, ExportTypes } from "~/modules/downloads/types";
import { ApiQueryEndpoints, ApiQueryExample } from "../../types";

// // // //

export interface ExportDataControlsConfig {
    enabled: boolean;
    allowedExportTypes?: ExportTypes[];
    exportTableName: ExportTableNames;
    exportFilename?: string;
}

export interface ApiToolsControlsConfig {
    enabled: boolean;
    endpoint: ApiQueryEndpoints;
}

export enum SearchControlModes {
    Basic = "basic",
    Pro = "pro",
}

export interface SearchControlsConfig {
    enablePro: boolean;
    enableBasic: boolean;
    mode: SearchControlModes;
    onChangeMode: (updatedMode: SearchControlModes) => void;
}

export interface QueryExamplesControlsConfig {
    items: ApiQueryExample[];
    onSelectItem: (selectedExample: ApiQueryExample) => void;
}
